export const projectsData = [
  {
    id: 21,
    title: "Task Management System",
    date: "December, 2021",
    description:
      "A responsive Task Management App developed using React-JS for the frontend and Firebase for backend, auth, storage and database.",
    hosted: "https://task-management-system-d3404.web.app/",
    source: "https://github.com/prajvalhl/task-management-system",
  },
  {
    id: 20,
    title: "Video-KannadaClass101",
    date: "September, 2021",
    description:
      "A video library site which is in it's super early stages! ⚠️ Under Development! but you can still try it using the below link. This website is being made using MERN stack. This website is a part of another project, more details will be updated soon!",
    hosted: "http://video-kannadaclass101.netlify.app/",
    source: "https://github.com/prajvalhl/kannadaclass101-videolibrary",
  },
  {
    id: 19,
    title: "Shop-KannadaClass101",
    date: "September, 2021",
    description:
      "An e-commerce book store which is ⚠️ Under Development! but you can still try it using the below link. This website is being made using MERN stack. This website is a part of another project, more details will be updated soon!",
    hosted: "http://shop-kannadaclass101.netlify.app/",
    source: "https://github.com/prajvalhl/kannada101-eshop",
  },
  {
    id: 18,
    title: "Portfolio Site (React-JS)",
    date: "June, 2021",
    description:
      "A Responsive Portfolio website which showcases my Projects, made using React-JS. Uses localStorage to save the theme (Light or Dark) of your choice across sessions and Uses React Router v6 (Stable) for routing. If you're reading this, you're already on my website right now! Cheers!",
    hosted: "https://prajvalhl.netlify.app/",
    source: "https://github.com/prajvalhl/prajval-portfolio-react",
  },
  {
    id: 17,
    title: "comp-libr",
    date: "April, 2021",
    description:
      "A fully responsive Custom CSS Component Library created using HTML, CSS and Vanilla-JS (ES6).",
    hosted: "https://comp-libr.netlify.app/",
    source: "https://github.com/prajvalhl/comp-libr",
  },
  {
    id: 16,
    title: "Pacific International",
    date: "November, 2021",
    description:
      "A fully responsive Company Portfolio Website made for a client, Pacific International, Bangalore, created using React-JS.",
    hosted: "https://pacific-international.netlify.app/",
    source: "https://github.com/prajvalhl/pacific-international",
  },
  {
    id: 15,
    title: "Portfolio Site (Vanilla-JS)",
    date: "February, 2021",
    description:
      "A Responsive Portfolio website which showcases my projects. This website is created using HTML, CSS and Vanilla-JS (ES6).",
    hosted: "https://prajvalhl-old.netlify.app/",
    source: "https://github.com/prajvalhl/prajval-portfolio",
  },
  {
    id: 14,
    title: "All about Triangles",
    date: "February, 2021",
    description:
      "This fun little responsive app will ask you quiz about triangles. You can also calculate Hypotenuse and area of triangle and find if your angles makes a triangle. This app is created using React-JS.",
    hosted: "https://d4f17.csb.app/",
    source: "https://github.com/prajvalhl/triangles-quiz",
  },
  {
    id: 13,
    title: "What's this Food Emoji?",
    date: "January, 2021",
    description:
      "This simple responsive app will interpret food / drink emojis. Put a Food emoji and it will tell what food it is. This app is created using React-JS.",
    hosted: "https://qv6p8.csb.app/",
    source: "https://github.com/prajvalhl/emojiInterpreter",
  },
  {
    id: 12,
    title: "Dad Jokes",
    date: "October, 2021",
    description:
      "This responsive React-JS app fetches random jokes from dad jokes api (icanhazdadjoke) and displays.",
    hosted: "https://hel60.csb.app/",
    source: "https://github.com/prajvalhl/dad-jokes",
  },
  {
    id: 11,
    title: "Test if your Birthdate is Palindrome",
    date: "January, 2021",
    description:
      "This app takes in your birthday as input and tells you if your birthdate is palindrome or if not, it'll tell you the closest palindrome date. This responsive app was created using HTML, CSS and Vanilla-JS (ES6). ",
    hosted: "https://prajvalhl.github.io/palindrome-birthday/",
    source: "https://github.com/prajvalhl/palindrome-birthday",
  },
  {
    id: 10,
    title: "Talk Dothraki",
    date: "January, 2021",
    description:
      "This is a translation app that converts from English to Dothraki language. This small responsive app was created using HTML, CSS and Vanilla-JS (ES6). For more details - readme.md",
    hosted: "https://prajvalhl.github.io/talk-dothraki/",
    source: "https://github.com/prajvalhl/talk-dothraki",
  },
  {
    id: 9,
    title: "Stocks: Profit or Loss Calculator",
    date: "January, 2021",
    description:
      "This app takes in the price at which you bought a stock, number of stocks and the current price of the stock and tells you if you're making a profit or loss off of it. This app is created using React-JS.",
    hosted: "https://qny2k.csb.app/",
    source: "https://github.com/prajvalhl/stocks-profit-or-loss",
  },
  {
    id: 8,
    title: "Cash Register Manager",
    date: "January, 2021",
    description:
      "A simple responsive Cash Register Manager app written using React-JS. Helps one to know the minimum number of cash to return for a given bill amount.",
    hosted: "https://33gn9.csb.app/",
    source: "https://github.com/prajvalhl/cash-register-manager",
  },
  {
    id: 7,
    title: "Is your birthday lucky?",
    date: "January, 2021",
    description:
      "This fun little React-JS app tells if your birthday is lucky or not based on your birth date and your lucky number. Try it!",
    hosted: "https://ikrv9.csb.app/",
    source: "https://github.com/prajvalhl/is-birthday-lucky",
  },
  {
    id: 6,
    title: "Dicegame 2.0",
    date: "December, 2020",
    description:
      "A small non-responsive fun dice game, created using Vanilla-JS (ES6). First to score 100 points wins!! This is same as the dicegame but with different UI. For more details - readme.md",
    hosted: "https://prajvalhl.github.io/dicegame-2.0/",
    source: "https://github.com/prajvalhl/dicegame-2.0",
  },
  {
    id: 5,
    title: "Dicegame",
    date: "November, 2020",
    description:
      "A small non-responsive fun dice game, created using Vanilla-JS (ES5). First to score 100 points / custom winning score wins!! For more details - readme.md",
    hosted: "https://prajvalhl.github.io/dicegame/",
    source: "https://github.com/prajvalhl/dicegame",
  },
  {
    id: 4,
    title: "Budgety",
    date: "October, 2020",
    description:
      "A simple non-responsive app for calculating monthly budget. This app is created using HTML, CSS and Vanilla-JS (ES5).",
    hosted: "https://prajvalhl.github.io/budgety/",
    source: "https://github.com/prajvalhl/budgety",
  },
  {
    id: 3,
    title: "Guess My Number",
    date: "December, 2020",
    description:
      "A small non-responsive fun vanilla-JS (ES6) game to guess the numbers between 1 and 20.",
    hosted: "https://prajvalhl.github.io/Guess-My-Number/",
    source: "https://github.com/prajvalhl/Guess-My-Number",
  },
  {
    id: 2,
    title: "Modal",
    date: "December, 2020",
    description:
      "A primitive modal window created using CSS and vanilla-JS (ES6).",
    hosted: "https://prajvalhl.github.io/Modal/",
    source: "https://github.com/prajvalhl/Modal",
  },
  {
    id: 1,
    title: "How woke are you?",
    date: "January, 2021",
    description:
      "A CLI App built with nodeJS. You can share this to your friends and find out who really are woke.",
    hosted: "https://repl.it/@prajvalhl/CLI-end-game-neo-g?embed=1&output=1",
    source: "https://repl.it/@prajvalhl/CLI-end-game-neo-g#index.js",
  },
];

export const blogsData = [
  {
    id: 2,
    title: "JavaScript Classes and Why?",
    date: "November, 2021",
    description:
      "Hey everyone! In this blog, let's learn what are classes in JavaScript and why we use them.",
    link: "https://prajvalhl.hashnode.dev/javascript-classes-and-why",
  },
  {
    id: 1,
    title: "How to download a React project from GitHub and run it locally.",
    date: "October, 2021",
    description:
      "As a beginner, have you ever wondered how do I run the React project which I cloned from GitHub on my machine? Here's a step by step instruction for that.",
    link: "https://prajvalhl.hashnode.dev/how-to-download-a-react-project-from-github-and-run-it-locally",
  },
];
